import { Component, ContentChildren, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, NavigationError, NavigationStart, ResolveEnd, Router, RouterEvent, RouterOutlet } from '@angular/router';
import { Observable, of, Subscription, timer } from 'rxjs';
import { OnlineService } from './core/utils/online.service';
import { LoadingScreenService } from './shared/services/loading-screen/loading-screen.service';
import {
    trigger,
    style,
    transition,
    animate,
    query,
} from "@angular/animations";
import { delay, filter, map, mergeMap, repeat, switchMap, tap } from 'rxjs/operators';
import { NavigationService } from './core/services/navigation/navigation.service';
import { registerLocaleData } from '@angular/common';
// import * as LogRocket from 'logrocket';
import { User } from './shared/models/User';
import * as LogRocket from 'logrocket';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { OktaAuthStateService } from '@okta/okta-angular';
import { SiteTitleService } from './shared/services/site-title.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginFormComponent } from './shared/components/login-form/login-form.component';
import { LocaleService } from './LocaleService';
import { AuthenticationService } from './modules/authentication/authentication.service';
import { ThemeService } from './shared/services/theme/theme.service';
import { ThemeConfig } from './shared/services/theme/theme.types';
import { MatSnackBar } from '@angular/material/snack-bar';
import { VersionCheckService } from './core/services/version-check/version-check.service';
import { GlobalErrorHandler } from './core/error-handler/global-error.handler';
export const NAVIGATION_COOKIE = 'NavigationHistory';

enum ThemeStyle {
    ESPP = 'theme-assurant.css',
    EPG = 'theme-assurant.css',
    CNH = 'theme-cnh.css',
    PPSP = 'theme-ppsp.css',
    BOMAG = 'theme-bomag.css',
    ASSURANT = 'theme-assurant.css',
    DYNAPAC = 'theme-dynapac.css',
    LIEBHERR = 'theme-liebherr.css' // New theme style for Liebherr
}

enum Favicon {
    ESPP = 'assurant-favicon.ico',
    CNH = 'ppp-favicon.ico',
    PPSP = 'ppsp-favicon.ico',
    BOMAG = 'bomag-favicon.ico',
    DYNAPAC = 'dynapac-favicon.ico',
    LIEBHERR = 'liebherr-favicon.ico' // New favicon for Liebherr
}

enum Domain {
    ESPP = 'ESPP',
    CNH = 'CNH',
    PPSP = 'PPSP',
    BOMAG = 'BOMAG',
    ASSURANT = 'ASSURANT',
    DYNAPAC = 'DYNAPAC',
    LIEBHERR = 'LIEBHERR' // New domain for Liebherr
}


export const slideInAnimation =
    trigger('routeAnimations', [
        transition('* => *', [

            query(':enter',
                [
                    style({ opacity: 0 })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({ opacity: 1 }),
                    animate('0.01s', style({ opacity: 0 }))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({ opacity: 0 }),
                    animate('0.2s', style({ opacity: 1 }))
                ],
                { optional: true }
            )

        ])
    ]);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [slideInAnimation],
})
export class AppComponent implements OnInit, OnDestroy {
    title = '';
    onlineSubscription: Observable<boolean> = new Observable<boolean>();
    navigationSubscrition = new Subscription();
    userSubscription = new Subscription();
    themeSubscription = new Subscription();
    versionUpdateSubscription = new Subscription();
    private versionCheckIntervalId: number | null = null;
    private removeFocusListener: (() => void) | null = null;
    private removeVisibilityListener: (() => void) | null = null;
    currentTheme: ThemeConfig | null = null;
    locale: string = 'en-US';
    
    // Custom loader properties
    showCustomLoader: boolean = false;

    constructor(
        private authService: AuthenticationService,
        private connectionSerive: OnlineService,
        private loadingScreenService: LoadingScreenService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private titleService: SiteTitleService,
        private dialog: MatDialog,
        @Inject(DOCUMENT) private document: Document,
        private okta: OktaAuthStateService,
        private themeService: ThemeService,
        private snackBar: MatSnackBar,
        private versionCheckService: VersionCheckService) {
    
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let child = this.activatedRoute.firstChild;
                while (child) {
                    if (child.firstChild) {
                        child = child.firstChild;
                    } else if (child.snapshot.data &&    child.snapshot.data['title']) {
                        return child.snapshot.data['title'];
                    } else {
                        return null;
                    }
                }
                return null;
            })
        )
        .subscribe( (data: any) => {
            // this.siteTitle.setTitle('test');
            this.titleService.setTitle(data);
        });
    }
    public get domain() {
        const hostname = window.location.hostname;
        switch(hostname){
            case 'dev-ppp.epgins.com':
            case 'espp-integration-model.epgins.com':
            case 'ppp.cnhinsurance.com':
            case 'espp-integration-qa.epgins.com':
            case 'dev-cnh.epgins.com':
            case 'model-espp-cnh.assurant.com':
            case 'qa-espp-cnh.assurant.com':
            case 'model-espp-cnhau.assurant.com': // New URL
            case 'qa-espp-cnhau.assurant.com': // New URL
            case 'espp-cnh.assurant.com':
            case 'espp-cnhau.assurant.com':
                return Domain.CNH;
            case 'dev-ppsp.epgins.com':
            case 'model-espp-protectionpoint.assurant.com':
            case 'qa-espp-protectionpoint.assurant.com':
            case 'protectionpointportal.com': // New URL
            case 'www.protectionpointportal.com': // New URL
            case 'espp-protectionpoint.assurant.com':
                return Domain.PPSP;
            case 'dev-bomag.epgins.com':
            case 'model-espp-bomag.assurant.com':
            case 'qa-espp-bomag.assurant.com':
            case 'bomagespp.com': // New URL
            case 'www.bomagespp.com': // New URL
            case 'espp-bomag.assurant.com':
                return Domain.BOMAG;
            case 'dev-dynapac.epgins.com':
            case 'model-espp-dynapac.assurant.com': // New URL
            case 'qa-espp-dynapac.assurant.com': // New URL
            case 'dynapacespp.com': // New URL
            case 'www.dynapacespp.com': // New URL
            case 'espp-dynapac.assurant.com':
                return Domain.DYNAPAC;
            case 'dev-liebherr.epgins.com': // New URL
            case 'qa-espp-liebherr.assurant.com': // New URL
            case 'model-espp-liebherr.assurant.com': // New URL
            case 'espp-liebherr.assurant.com':
                return Domain.LIEBHERR; // Assuming a new theme style "LIEBHERR" for Liebherr
            default:
                return Domain.ESPP
        }
    }
    public get themeName(){
        const domain = this.domain;
        return ThemeStyle[domain];
    }

    public get favicon(){
        const domain = this.domain;
        return Favicon[domain];
    }

    loadFavicon() {
        let styleName = this.favicon
        const head = this.document.getElementsByTagName('head')[0];

        //https://juristr.com/blog/2019/08/dynamically-load-css-angular-cli/
        const style = this.document.createElement('link');
        style.rel = 'image/x-icon';
        style.id = 'client-favicon';
        style.rel = 'icon';
        style.href = `./assets/favicons/${styleName}`;

        head.appendChild(style);
    }

    loadStyle() {
        const params = new URLSearchParams(window.location.search);
        const themeOverwrite = params.get('theme')
        let styleName = this.themeName
        const head = this.document.getElementsByTagName('head')[0];

        let themeLink = this.document.getElementById(
            'client-theme'
        ) as HTMLLinkElement;

        if(themeOverwrite && (themeOverwrite.toUpperCase()) in ThemeStyle){
           styleName = ThemeStyle[themeOverwrite.toUpperCase()];
        }

        //https://juristr.com/blog/2019/08/dynamically-load-css-angular-cli/
        const style = this.document.createElement('link');
        style.id = 'client-theme';
        style.rel = 'stylesheet';
        style.href = `${styleName}`;

        head.appendChild(style);
    }

    ngOnDestroy(): void {
        this.navigationSubscrition.unsubscribe();
        this.userSubscription.unsubscribe();
        this.themeSubscription.unsubscribe();
        this.versionUpdateSubscription.unsubscribe();
        if (this.versionCheckIntervalId !== null) {
            window.clearInterval(this.versionCheckIntervalId);
        }
        if (this.removeFocusListener) {
            this.removeFocusListener();
        }
        if (this.removeVisibilityListener) {
            this.removeVisibilityListener();
        }
    }

    ngOnInit(): void {
        // this.authService.autoLogin();
        this.onlineSubscription = this.connectionSerive.isOnline();
        this.initializeVersionChecks();

        // const poll = this.okta.authState$.pipe(
        //     filter(tokens => tokens.accessToken !== undefined),
        //     filter(_ => !this.authService.storedUser),
        //     mergeMap(_ => this.authService.getUserData()),
        //     tap((d) => console.log(d)),
        //     delay(60000*10),
        //     repeat()
        //   );

        //   poll
        //     .subscribe(user => {
        //         console.log(user)
        //         this.authService.user.next(user);
        //         this.authService.storeUser(user);
        //     });

        // timer(1,60000)
        // .pipe(
        //     switchMap( interval => this.okta.authState$),
        //     filter(tokens => {
        //         return (tokens.accessToken !== undefined &&  !('refreshToken' in tokens))
        //     }),
        //     map(tokens => {
        //         if(tokens.accessToken){
        //             const expiresAt = tokens.accessToken.expiresAt * 1000;
        //             const seconds =  (expiresAt - Date.now())/1000;
        //             return {loggedIn: true, remainingSeconds: seconds};
        //         }
        //         return {loggedIn: false, remainingSeconds: 0};
        //     })
        // )
        // .subscribe(tokens => {
        //     //console.log(tokens)
        //    if(!tokens.loggedIn){
        //     //console.log('need to reauth')
        //    }

        //    if(tokens.loggedIn && tokens.remainingSeconds < (60*10)){
        //         const loginForm = this.dialog.openDialogs.find( ref => ref.componentInstance instanceof LoginFormComponent);
        //         if (loginForm) return;
        //         this.dialog.open(LoginFormComponent,{disableClose: true, closeOnNavigation: false})
        //    }
        // })

        
        // if (window.location.hostname !== "localhost") {
        // LogRocket.init('jdmknw/espp');
        // const localData = localStorage.getItem('user');
        // if (localData) {
        //     const userData: User = JSON.parse(localData);
        //     LogRocket.identify(''+userData.email, {
        //         name: `${userData.first_name} ${userData.last_name}`,
        //         email: userData.email,
        //         domain: window.location.host
        //       });
        //  }
        // }

        this.navigationSubscrition = this.router.events.subscribe((event: any): void => {
            if (event instanceof NavigationEnd) {
                  const params = new URLSearchParams(window.location.search);
                  const theme = params.get('theme');
                  if (this.isPreAuthRoute(event.urlAfterRedirects || event.url)) {
                    if (this.canAutoReloadForVersion(event.urlAfterRedirects || event.url) && this.versionCheckService.isUpdateAvailable) {
                        window.location.reload();
                    } else if (!this.isSsoCallbackRoute(event.urlAfterRedirects || event.url)) {
                        this.versionCheckService.checkForUpdate();
                    }
                  }
                  
                //   if(theme){
                //     this.router.navigate([], {
                //         queryParams: {
                //           theme: theme
                //         },
                //         queryParamsHandling: 'merge',
                //       });
                //   }
             }
            if (event instanceof NavigationError) {
                GlobalErrorHandler.reloadForChunkLoadError(event.error);
            }
        })
        // Detect SSO authentication to skip background refresh and reduce API calls
        const urlParams = new URLSearchParams(window.location.search);
        const isSsoAuth = urlParams.has('iss') || urlParams.has('code');
        
        // Check if theme cache exists (need assets for login page images)
        const hasCache = !!localStorage.getItem('app_theme_cache');
        
        // Load theme - show loader during SSO only if no cache (need to fetch assets)
        // Always show loader for non-SSO pages
        if (!isSsoAuth || !hasCache) {
          this.showCustomLoader = true;
        }
        const themeLoadStartTime = Date.now();
        const minLoaderTime = (isSsoAuth && hasCache) ? 0 : 1000; // Immediate hide for SSO with cache
        
        this.themeSubscription = this.themeService.loadThemeFromAPI(undefined, isSsoAuth).subscribe(theme => {
          if (theme) {
            this.currentTheme = theme;
            
            // Manage loader timing
            if (this.showCustomLoader) {
              // For SSO with cache: hide immediately (synchronous)
              // For others: maintain minimum loader time
              if (isSsoAuth && hasCache) {
                this.showCustomLoader = false;
              } else {
                const elapsed = Date.now() - themeLoadStartTime;
                const remainingTime = Math.max(minLoaderTime - elapsed, 0);
                
                setTimeout(() => {
                  this.showCustomLoader = false;
                }, remainingTime);
              }
            }
          } else if (this.showCustomLoader) {
            this.showCustomLoader = false;
          }
        });

    }

    // Shows and hides the loading spinner during RouterEvent changes
    navigationInterceptor(event): void {
        if (event instanceof NavigationStart) {
            this.loadingScreenService.startLoading();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationEnd) {
            this.loadingScreenService.stopLoading();
        }
        if (event instanceof NavigationError) {
            this.loadingScreenService.stopLoading();
        }
    }

    prepareRoute(outlet: RouterOutlet) {
        return outlet.isActivated ? outlet.activatedRoute : '';
    }

    private initializeVersionChecks(): void {
        this.versionCheckService.initialize();

        const focusHandler = () => this.versionCheckService.checkForUpdate();
        const visibilityHandler = () => {
            if (!this.document.hidden) {
                this.versionCheckService.checkForUpdate();
            }
        };

        window.addEventListener('focus', focusHandler);
        this.document.addEventListener('visibilitychange', visibilityHandler);
        this.removeFocusListener = () => window.removeEventListener('focus', focusHandler);
        this.removeVisibilityListener = () => this.document.removeEventListener('visibilitychange', visibilityHandler);
        this.versionCheckIntervalId = window.setInterval(
            () => this.versionCheckService.checkForUpdate(),
            this.versionCheckService.intervalMs
        );

        this.versionUpdateSubscription = this.versionCheckService.updateAvailable$
            .pipe(filter(updateAvailable => updateAvailable))
            .subscribe(() => {
                if (this.canAutoReloadForVersion(this.router.url)) {
                    window.location.reload();
                    return;
                }

                const snackBarRef = this.snackBar.open('New version available', 'Reload', {
                    duration: 0,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['version-update-snackbar'],
                });

                snackBarRef.onAction().subscribe(() => window.location.reload());
            });
    }

    private isPreAuthRoute(url: string): boolean {
        const path = (url || '').split('?')[0].split('#')[0].toLowerCase();
        return path === '/' ||
            path === '' ||
            path.startsWith('/login') ||
            path.startsWith('/authentication') ||
            path.startsWith('/register') ||
            path.startsWith('/forgot') ||
            path.startsWith('/password') ||
            path.startsWith('/reset');
    }

    private canAutoReloadForVersion(url: string): boolean {
        return this.isPreAuthRoute(url) && !this.isSsoCallbackRoute(url);
    }

    private isSsoCallbackRoute(url: string): boolean {
        const query = (url || '').split('?')[1] || '';
        const params = new URLSearchParams(query.split('#')[0]);
        return params.has('iss') || params.has('code');
    }

    private getUsersLocale(): string {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return 'en-US';
        }
        const wn = window.navigator as any;
        let lang = wn.languages ? wn.languages[0] : 'en-US';
        lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
        return lang;
    }
}
